// src/components/layouts/PartnerLayout.tsx
import { Outlet } from 'react-router-dom';
import PartnerSidebar from '@/components/navigation/PartnerSidebar';
import { AlertNotifications } from '@/components/ui/AlertNotifications';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePartnerDetails } from '@/hooks/usePartnerDetails';


export default function PartnerLayout() {
  const { profile } = useAuth();
  const { data: partnerDetails, isLoading: partnerLoading } = usePartnerDetails();

  // Show loading while checking partner status
  if (partnerLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if user is an actual partner (not a sub-account)
  const isSubAccount = profile?.user_type === 'partner_client';
  const isActualPartner = partnerDetails !== null && !isSubAccount;

  // Show access denied if user is not a partner
  if (!isActualPartner) {
    return (
      <div className="container mx-auto py-6">
        <Card>
          <CardHeader>
            <CardTitle>Access Denied</CardTitle>
            <CardDescription>Only partner users can access this area.</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              You need to have a partner account to access the partner dashboard. 
              Please contact support if you believe this is an error.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-muted">
      <PartnerSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto bg-background p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
      <AlertNotifications />
    </div>
  );
}